<div class="p-4" #printSection id="printSection">
  <div class="mt-4 mb-4 d-flex justify-content-center">
    <div>
      <img src="imgs/logo-agsus-ms.png" alt="" />
    </div>
  </div>

  <app-card-collapse
    [titulo]="'Informações da Vaga'"
    [isCollapsed]="false"
    [enableCollapse]="false"
    class="justify-content-center mt-4"
  >
    <hr />
    <div class="row info-container">
      <div class="col-3">
        <label for="">Ciclo do Edital</label>
        <span>{{
          ("00" + confirmacaoVaga.ciclo?.numeroCiclo).slice(-3) +
            "/" +
            confirmacaoVaga.ciclo?.anoCiclo
        }}</span>
      </div>
      <div class="col-3">
        <label for="">Ciclo do Edital</label>
        <span>{{ confirmacaoVaga.ciclo?.programa?.nome || "-" }}</span>
      </div>
      <div class="col-3">
        <label for="">Gestor Responsável</label>
        <span>{{ confirmacaoVaga?.usuario?.nome }}</span>
      </div>
      <div class="col-3">
        <label for="">Nivel da Vaga</label>
        <span>{{ "Municipal" }}</span>
      </div>
      <div class="col-3">
        <label for="">UF</label>
        <span>{{ confirmacaoVaga.municipio?.siglaUf }}</span>
      </div>
      <div class="col-3">
        <label for="">Município</label>
        <span>{{ confirmacaoVaga.municipio?.nome }}</span>
      </div>
      @if (this.confirmacaoVaga.dtFimConfirmacao) {
        <div class="col-3">
          <label for="">Data de Confirmação</label>
          <span>{{
            confirmacaoVaga.dataConfirmacao | date: "dd/MM/yyyy HH:mm"
          }}</span>
        </div>
      }
      <div class="col-3">
        <label for="">IBGE</label>
        <span>{{ confirmacaoVaga.municipio?.id }}</span>
      </div>
    </div>
  </app-card-collapse>

  @if (resumoVagas.length > 0) {
    <div class="p-4 mt-4 mb-4" style="background-color: rgba(244, 244, 244, 1)">
      <div class="row">
        <div class="col-3">
          <strong>Total de Vagas Confirmadas:</strong>
          <strong style="color: rgba(12, 50, 111, 1)">
            {{ totalVagasConfirmadas }}</strong
          >
        </div>
        @for (resumo of resumoVagas; track resumo.modalidade; let i = $index) {
          <div class="col-3">
            {{ resumo.modalidade }}:
            <strong style="color: rgba(12, 50, 111, 1)"
              >{{ resumo.total }}
            </strong>
          </div>
          {{ i < resumoVagas.length - 1 ? " | " : "" }}
        }
      </div>
    </div>
  }

  @for (item of data; track item.modalidadeId) {
    <div class="table-container mb-4">
      <app-table-filter-bar [title]="item.modalidade" [showSearch]="false">
      </app-table-filter-bar>

      <table class="table-result">
        <thead>
          <tr>
            <th scope="col">Vagas</th>
            <th scope="col">INE</th>
            <th scope="col">Nome da Equipe INE</th>
            <th scope="col">Tipo da Equipe</th>
            <th scope="col">CNES</th>
            <th scope="col">Nome do Estabelecimento</th>
          </tr>
        </thead>
        <tbody>
          @for (
            value of item.pages[item.currentPage - 1].data;
            track value.id;
            let i = $index
          ) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ value.vagaCicloIne.nuIne }}</td>
              <td>{{ value.vagaCicloIne.nomeEquipe }}</td>
              <td>{{ value.vagaCicloIne.tipoEquipe.nome }}</td>
              <td>{{ value.vagaCicloIne.coCnes }}</td>
              <td>{{ value.vagaCicloIne.nomeEstabelecimento }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (cadastrosReservaMunicipio.length > 0) {
    <div class="table-container mb-4">
      <app-table-filter-bar [title]="'Cadastro Reserva'" [showSearch]="false">
      </app-table-filter-bar>

      <table class="table-result">
        <thead>
          <tr>
            <th scope="col">Equipe</th>
            <th scope="col">Confirmado</th>
          </tr>
        </thead>
        <tbody>
          @for (item of cadastrosReservaMunicipio; track item.id) {
            <tr>
              <td>{{ item.tipoEquipe.nome }}</td>
              <td>{{ item.stConfirmado ? "Sim" : "Não" }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
